import React, { FC, useMemo } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Icon, View } from "@lookiero/aurora";
import { Glyphs } from "@lookiero/aurora-iconfont";
import { Text } from "@lookiero/sty-psp-ui";
import { style as iconMessageStyle } from "./IconMessage.style";

interface IconMessageProps {
  readonly iconName?: keyof Glyphs;
  readonly title: string;
  readonly body: string;
  readonly style?: StyleProp<ViewStyle>;
}

const IconMessage: FC<IconMessageProps> = ({ iconName = "tick_fill", title, body, style: customStyle }) => {
  const style = useMemo(() => iconMessageStyle(), []);

  return (
    <View style={[style.wrapper, customStyle]}>
      <View style={style.container}>
        <Icon name={iconName} style={style.icon}></Icon>

        <Text level={3} style={style.title} variant="heading">
          {title}
        </Text>

        <Text level={3} style={style.body}>
          {body}
        </Text>
      </View>
    </View>
  );
};

export { IconMessage };
